export async function fetchStateData(facilityType) {
    const response = await fetch(`/stats/data/${facilityType}`);
    const data = await response.json();
    return data;
}
